import React from "react";
import { useTranslation } from "../i18n";

const LoadingSpinner = () => {
  const { t } = useTranslation();
  return (
    <div className="loading-bar" role="progressbar" aria-label={t("common.loading")}>
      <span className="loading-bar__fill" />
    </div>
  );
};

export default LoadingSpinner;
